import { render } from "./ServicesMobile.vue?vue&type=template&id=29cb93c9&scoped=true"
import script from "./ServicesMobile.vue?vue&type=script&lang=js"
export * from "./ServicesMobile.vue?vue&type=script&lang=js"

import "./ServicesMobile.vue?vue&type=style&index=0&id=29cb93c9&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29cb93c9"]])

export default __exports__